import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  HostListener,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Platform } from '@ionic/angular';
import { ServiceService } from 'src/app/mastermodule/service/service.service';
import { Storage } from '@ionic/storage';
import { Capacitor } from '@capacitor/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

export interface NavItemConfig {
  key: string;
  section: string;
  title: string;
  desc: string;
  url: string;
  icon: string;
  color: string;
  breadcrumb: string[];
  privilegeId?: string;
  routeClass?: string;
}

export const PAGE_REGISTRY: NavItemConfig[] = [
  // --- Home ---
  {
    key: 'dashboard',
    section: 'home',
    title: 'Dashboard',
    desc: 'Main overview & stats',
    url: '/master',
    icon: 'fa fa-chart-pie',
    color: 'teal',
    breadcrumb: ['Home', 'Overview', 'Dashboard'],
    routeClass: 'sidebar-mainmenu-home'
  },

  // --- Campaigns (WhatsApp) ---
  {
    key: 'mod0278',
    section: 'campaigns',
    title: 'New Messages',
    desc: 'Compose & send instant messages',
    url: '/master/mod0278',
    icon: 'fa-solid fa-paper-plane',
    color: 'emerald',
    breadcrumb: ['Campaigns', 'Whatsapp', 'New Messages'],
    privilegeId: '4',
    routeClass: 'sidebar-submenu-individual-message'
  },
  {
    key: 'mod0277',
    section: 'campaigns',
    title: 'Messages',
    desc: 'Message history & delivery logs',
    url: '/master/mod0277',
    icon: 'fa-solid fa-clock-rotate-left',
    color: 'blue',
    breadcrumb: ['Campaigns', 'Whatsapp', 'Messages'],
    privilegeId: '3',
    routeClass: 'sidebar-submenu-individual-history'
  },
  // {
  //   key: 'mod0278',
  //   section: 'campaigns',
  //   title: 'Messages',
  //   desc: 'Message history & delivery logs',
  //   url: '/master/mod0278',
  //   icon: 'fa-solid fa-clock-rotate-left',
  //   color: 'blue',
  //   breadcrumb: ['Campaigns', 'Whatsapp', 'Messages'],
  //   privilegeId: '3',
  //   routeClass: 'sidebar-submenu-individual-history'
  // },
  {
    key: 'mod0274',
    section: 'campaigns',
    title: 'New Campaigns',
    desc: 'Launch bulk marketing broadcasts',
    url: '/master/mod0274',
    icon: 'fa-solid fa-bullhorn',
    color: 'purple',
    breadcrumb: ['Campaigns', 'Whatsapp', 'New Campaigns'],
    privilegeId: '1',
    routeClass: 'sidebar-submenu-new-broadcast'
  },
  {
    key: 'mod0275',
    section: 'campaigns',
    title: 'Campaigns',
    desc: 'View & manage campaign lists',
    url: '/master/mod0275',
    icon: 'fa-solid fa-layer-group',
    color: 'amber',
    breadcrumb: ['Campaigns', 'Whatsapp', 'Campaigns'],
    privilegeId: '2',
    routeClass: 'sidebar-submenu-campaigns'
  },

  // --- HRMS (User Management) ---
  {
    key: 'mod0118',
    section: 'hrms',
    title: 'User Type Privilege',
    desc: 'System privileges & roles',
    url: '/master/mod0118',
    icon: 'fa-solid fa-shield-halved',
    color: 'teal',
    breadcrumb: ['HRMS', 'User', 'User Type Privilege'],
    privilegeId: '8',
    routeClass: 'sidebar-submenu-route-privilege'
  },
  {
    key: 'mod0113',
    section: 'hrms',
    title: 'User Privilege',
    desc: 'Assign privileges to users',
    url: '/master/mod0113',
    icon: 'fa-solid fa-user-shield',
    color: 'blue',
    breadcrumb: ['HRMS', 'User', 'User Privilege'],
    privilegeId: '9',
    routeClass: 'sidebar-submenu-route-user_privilege'
  },
  {
    key: 'mod0500',
    section: 'hrms',
    title: 'User Type',
    desc: 'User type configuration',
    url: '/master/mod0500',
    icon: 'fa-solid fa-users-gear',
    color: 'purple',
    breadcrumb: ['HRMS', 'User', 'User Type'],
    privilegeId: '5',
    routeClass: 'sidebar-submenu-route-user_type_master'
  },
  {
    key: 'mod0501',
    section: 'hrms',
    title: 'User Process',
    desc: 'User Process',
    url: '/master/mod0501',
    icon: 'fa-solid fa-users-gear',
    color: 'purple',
    breadcrumb: ['HRMS', 'User', 'User Process'],
    privilegeId: '7',
    routeClass: 'sidebar-submenu-route-user_type_process'
  },
  {
    key: 'mod0116',
    section: 'hrms',
    title: 'Edit Kyc',
    desc: 'Modify KYC user details',
    url: '/master/mod0116',
    icon: 'fa-solid fa-user-pen',
    color: 'amber',
    breadcrumb: ['HRMS', 'User', 'Edit Kyc'],
    privilegeId: '13',
    routeClass: 'sidebar-submenu-route-edit_kyc'
  },

  // --- Notification ---
  {
    key: 'mod0476',
    section: 'notification',
    title: 'Notification Type',
    desc: 'Alert categories & templates',
    url: '/master/mod0476',
    icon: 'fa-solid fa-tags',
    color: 'teal',
    breadcrumb: ['Notification', 'Master', 'Notification Type'],
    privilegeId: '138',
    routeClass: 'sidebar-submenu-route-brand'
  },
  {
    key: 'mod0477',
    section: 'notification',
    title: 'Notification Broadcast',
    desc: 'Send system-wide broadcasts',
    url: '/master/mod0477',
    icon: 'fa-solid fa-tower-broadcast',
    color: 'purple',
    breadcrumb: ['Notification', 'Master', 'Notification Broadcast'],
    privilegeId: '139',
    routeClass: 'sidebar-submenu-route-brand'
  },

  // --- Settings ---
  {
    key: 'mod0119',
    section: 'setting',
    title: 'Profile',
    desc: 'Manage user account profile',
    url: '/master/mod0119',
    icon: 'fa-solid fa-circle-user',
    color: 'teal',
    breadcrumb: ['Settings', 'Account', 'Profile'],
    privilegeId: '16',
    routeClass: 'sidebar-submenu-profile'
  },
  {
    key: 'mod0185',
    section: 'setting',
    title: 'Change Password',
    desc: 'Update account security password',
    url: '/master/mod0185',
    icon: 'fa-solid fa-key',
    color: 'blue',
    breadcrumb: ['Settings', 'Account', 'Change Password'],
    routeClass: 'sidebar-submenu-change_password'
  }
];

@Component({
  selector: 'app-whatsapp-navbar',
  templateUrl: './whatsapp-navbar.component.html',
  styleUrls: ['./whatsapp-navbar.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class WhatsappNavbarComponent implements OnInit, OnDestroy, OnChanges {

  readonly pageRegistry = PAGE_REGISTRY;

  key_session = '';
  user_name = '';
  user_type = '';
  user_id = '';

  sideBarPinned: boolean = false;
  isDrawerOpen: boolean = false;
  activeSection: string = 'campaigns';
  showUserMenu: boolean = false;

  // Live Clock & Date Properties
  currentDateString: string = '';
  currentTimeString: string = '';
  private clockInterval: any;
  private destroy$ = new Subject<void>();

  nav_loading = true;
  isOpen: boolean = false;
  isActive: any;
  selectedCompany: any = null;

  privilage_array: string[] = [];
  NAME_OF_USER = '';
  head_variable: any;
  modName: string = '';
  appPlatform: string = '';
  isSidebarOpen = false;

  constructor(
    private storage: Storage,
    public api: ServiceService,
    public platform: Platform,
    private router: Router,
    private cookies: CookieService,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) {
    this.key_session = this.api.get_session_id_login();

    if (!this.key_session) {
      this.api.logout();
    } else {
      this.user_name = this.api.get_user_details_in_cookies();
      this.user_id = this.api.localStorage.getItem('user_id');
      this.user_type = this.api.localStorage.getItem('user_type');
      this.NAME_OF_USER = this.user_name;

      if (!this.user_id || !this.user_type) {
        this.api.logout();
      }

      this.modName = this.api.SplitUrl(window.location.href).split('?')[0];
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        const currentUrl = event.urlAfterRedirects || event.url || '';
        this.updateActiveSectionFromUrl(currentUrl);

        setTimeout(() => {
          this.applySidebarState();
          this.applyActiveRouteColor();
        }, 50);
      });
  }

  ngOnChanges(changes: SimpleChanges): void { }

  ngOnInit() {
    this.startLiveClock();

    this.sideBarPinned =
      this.api.localStorage.getItem('sideBarPinned') === 'true';

    this.appPlatform = Capacitor.getPlatform();

    // Render navbar immediately
    this.nav_loading = false;

    // Load other information afterwards
    this.selectedCompany = this.loadFromStorage();
    this.loadSelectedCompanyFromDB();

    this.api.companyUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((updatedCompany) => {
        if (updatedCompany) {
          this.selectedCompany = updatedCompany;
        }
      });

    const cachedPrivileges = this.api.localStorage.getItem('cached_privileges');
    if (cachedPrivileges) {
      try {
        const parsed = JSON.parse(cachedPrivileges);
        if (Array.isArray(parsed) && parsed.length > 0) {
          this.privilage_array = parsed.map((x: any) => String(x));
        }
      } catch (e) {
        console.warn('Error loading cached privileges:', e);
      }
    }

    if (this.user_id && this.user_type) {
      this.get_privilage_function({
        user_id: this.user_id,
        user_type: this.user_type,
      });
    }

    this.api.sharedData$
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.head_variable = data;
      });

    this.updateActiveSectionFromUrl(window.location.href);

    if (this.sideBarPinned) {
      this.isDrawerOpen = true;
    }

    this.applySidebarState();
    this.applyActiveRouteColor();
  }

  ngOnDestroy() {
    if (this.clockInterval) {
      clearInterval(this.clockInterval);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  startLiveClock() {
    this.updateClock();
    this.clockInterval = setInterval(() => {
      this.updateClock();
    }, 10000);
  }

  updateClock() {
    const now = new Date();
    const optionsDate: Intl.DateTimeFormatOptions = { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' };
    this.currentDateString = now.toLocaleDateString('en-US', optionsDate);

    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const hoursStr = hours.toString().padStart(2, '0');
    this.currentTimeString = `${hoursStr}:${minutes} ${ampm}`;
  }

  updateActiveSectionFromUrl(url: string) {
    if (!url) return;
    const match = this.pageRegistry.find(page => url.includes(page.key));
    if (match) {
      this.activeSection = match.section;
    } else if (url.includes('/master')) {
      this.activeSection = 'home';
    }
  }

  getInitials(name: string): string {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }

  getSectionTitle(key: string): string {
    switch (key) {
      case 'home': return 'Home';
      case 'campaigns': return 'Campaigns';
      case 'hrms': return 'HRMS';
      case 'notification': return 'Notification';
      case 'setting': return 'Settings';
      default: return 'WhatsApp Manager';
    }
  }

  getSectionFolderTitle(key: string): string {
    switch (key) {
      case 'home': return 'Overview';
      case 'campaigns': return 'Whatsapp';
      case 'hrms': return 'User';
      case 'notification': return 'Master';
      case 'setting': return 'Settings';
      default: return 'Overview';
    }
  }

  getSectionFolderIcon(key: string): string {
    switch (key) {
      case 'home': return 'fa fa-home';
      case 'hrms': return 'fa fa-user hrms-color';
      case 'notification': return 'fa fa-users notify-color';
      case 'setting': return 'fa fa-cog setting-color';
      default: return 'fa-solid fa-layer-group';
    }
  }

  getActiveSectionPages(): NavItemConfig[] {
    return this.pageRegistry.filter(p => p.section === this.activeSection);
  }

  getBreadcrumbTrail(): string[] {
    const url = window.location.href || '';
    const match = this.pageRegistry.find(page => url.includes(page.key));
    if (match) {
      return match.breadcrumb;
    }

    const sectionDefaults: Record<string, string[]> = {
      campaigns: ['Campaigns', 'Whatsapp', 'Overview'],
      hrms: ['HRMS', 'User', 'Overview'],
      notification: ['Notification', 'Master', 'Overview'],
      setting: ['Settings', 'Account', 'Profile'],
      home: ['Home', 'Overview', 'Dashboard']
    };

    return sectionDefaults[this.activeSection] || ['Home', 'Overview', 'Dashboard'];
  }

  onRailIconClick(sectionKey: string, defaultUrl?: string) {
    if (this.activeSection === sectionKey) {
      this.isDrawerOpen = !this.isDrawerOpen;
    } else {
      this.activeSection = sectionKey;
      this.isDrawerOpen = true;
    }

    if (defaultUrl) {
      this.routerNextPage(defaultUrl);
      if (!this.sideBarPinned) {
        this.isDrawerOpen = false;
      }
    }
  }

  onMenuItemClick(routeClass: string, url: string) {
    this.clickRouteNode(routeClass);
    this.routerNextPage(url);

    if (!this.sideBarPinned) {
      this.isDrawerOpen = false;
    }
  }

  toggleDrawer() {
    this.isDrawerOpen = !this.isDrawerOpen;
  }

  closeDrawer() {
    if (!this.sideBarPinned) {
      this.isDrawerOpen = false;
    }
  }

  togglePinSidebar(pinnedState?: any) {
    if (typeof pinnedState === 'boolean') {
      this.sideBarPinned = pinnedState;
    } else {
      this.sideBarPinned = !this.sideBarPinned;
    }

    this.api.localStorage.setItem('sideBarPinned', this.sideBarPinned ? 'true' : 'false');

    if (this.sideBarPinned) {
      this.isDrawerOpen = true;
    }

    this.applySidebarState();
  }

  applySidebarState() {
    const isPinned = this.sideBarPinned;
    const body = document.body;
    const container = this.elRef.nativeElement.querySelector('.crystal-navbar-container');

    if (isPinned) {
      this.isDrawerOpen = true;
      this.renderer.addClass(body, 'crystal-sidebar-pinned');
      this.renderer.removeClass(body, 'crystal-sidebar-collapsed');
      if (container) this.renderer.addClass(container, 'pinned');
    } else {
      this.renderer.addClass(body, 'crystal-sidebar-collapsed');
      this.renderer.removeClass(body, 'crystal-sidebar-pinned');
      if (container) this.renderer.removeClass(container, 'pinned');
    }
  }

  ShowUserProfile() {
    this.showUserMenu = !this.showUserMenu;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target) return;

    // Check user profile popover outside click
    const userContainer = this.elRef.nativeElement.querySelector('.crystal-user-container');
    if (userContainer && !userContainer.contains(target)) {
      this.showUserMenu = false;
    }

    // Check secondary drawer outside click
    const navbarContainer = this.elRef.nativeElement.querySelector('.crystal-navbar-container');
    if (navbarContainer && !navbarContainer.contains(target) && !this.sideBarPinned && this.isDrawerOpen) {
      this.isDrawerOpen = false;
    }
  }

  loadSelectedCompanyFromDB(): Promise<void> {
    return new Promise((resolve) => {
      const requestData = {
        pno: 1,
        pageSize: 9999,
        searchText: '',
        sortCol: 'company_name',
        sortDir: 'asc',
      };

      this.api.call_http_post({
        url: environment.API_URL + 'mastermodule/GetCompanyMaster',
        data: requestData,
        successCb: (res) => {
          const allCompanies = res.data?.CompanyData || [];
          const selected = allCompanies.find((x: any) => x.selectedflag === '1');

          if (selected) {
            this.selectedCompany = selected;
            this.saveToStorage(selected);
          } else {
            this.selectedCompany = this.loadFromStorage();
          }
          resolve();
        },
        errorCb: (err) => {
          console.error('API Error:', err);
          resolve();
        },
      });
    });
  }

  saveToStorage(company: any) {
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('selectedCompany', JSON.stringify(company));
      }
    } catch (error) {
      console.warn('Could not save to storage:', error);
    }
  }

  loadFromStorage() {
    try {
      if (typeof sessionStorage !== 'undefined') {
        const saved = sessionStorage.getItem('selectedCompany');
        return saved ? JSON.parse(saved) : null;
      }
    } catch (error) {
      console.warn('Could not load from storage:', error);
    }
    return null;
  }

  get_privilage_function(data: any) {
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/get_privilage_function',
      data,
      modname: this.modName,
      successCb: (res: any) => {
        const result = res?.data;
        const rawDt = result?.dt || [];
        const flatList = Array.isArray(rawDt) ? [].concat(...rawDt) : [];

        this.privilage_array = flatList
          .map((x: any) => {
            if (typeof x === 'object' && x !== null) {
              return String(x.page_id ?? x.id ?? x.privilege_id ?? '');
            }
            return String(x);
          })
          .filter((x: string) => x !== '');

        try {
          this.api.localStorage.setItem('cached_privileges', JSON.stringify(this.privilage_array));
        } catch (e) {
          console.warn('Could not cache privileges:', e);
        }

        this.nav_loading = false;

        setTimeout(() => {
          this.applyActiveRouteColor();
        }, 200);
      },
      afterError: (error) => {
        console.warn('Error fetching privileges:', error);
      },
    });
  }

  clickRouteNode(routeclass: string) {
    this.api.localStorage.setItem('Navbar_Route_Node', routeclass);
  }

  clickRouteNodeSubmenu(routeclass_submenu: string) {
    this.api.localStorage.setItem('Navbar_Route_Node_Submenu', routeclass_submenu);
  }

  clickRouteNodeMainmenu(routeclass_mainmenu: string) {
    this.api.localStorage.setItem('Navbar_Route_Node_Mainmenu', routeclass_mainmenu);
  }

  /**
   * Unified, clean privilege evaluator.
   * Compares the required privilege IDs provided in the template against the user's active permissions.
   * @param required Privileges required (single string, array of strings, or '0' for unrestricted)
   */
  hasPrivilege(required: string | string[]): boolean {
    if (!required) return true;

    const reqArray = Array.isArray(required) ? required : [required];
    if (reqArray.length === 0 || reqArray.includes('0')) return true;

    const userPrivileges = [
      ...this.privilage_array,
      ...(this.api?.privilage_array || [])
    ];

    // Check if user has ANY of the required privilege IDs
    return reqArray.some(reqId => userPrivileges.includes(String(reqId)));
  }

  /**
   * Backward-compatible alias for hasPrivilege
   */
  checkPrivilageArrayOr(arr: any[]): boolean {
    return this.hasPrivilege(arr);
  }

  routerNextPage(url: string) {
    this.router.navigate([url]);
  }

  applyActiveRouteColor() {
    const prevActive = this.elRef.nativeElement.querySelectorAll('.routeColor');
    prevActive.forEach((el: HTMLElement) => el.classList.remove('routeColor'));

    const child = this.api.localStorage.getItem('Navbar_Route_Node');
    if (child) {
      const match = this.elRef.nativeElement.querySelector('.' + child);
      if (match) {
        match.classList.add('routeColor');
      }
    }
  }

  navbarOpenClose(open: boolean, clickTrigger: boolean = false) {
    this.isDrawerOpen = open;
    if (clickTrigger && !open) {
      this.api.localStorage.setItem('sideBarPinned', 'false');
      this.sideBarPinned = false;
    }
  }

  submenuOpenClose(selected: any, selected_menu: any) {
    this.activeSection = selected;
  }
}
